import * as React from 'react';
import TextField from '@mui/material/TextField';

const MUIInputField = ({ label, name, className, value = '', type="text", validation_error = '', variant = "standard", ...props }) => {
    return (
        <>
            <div className='w-100 my-2'>
                <TextField
                    fullWidth
                    id={name}
                    name={name}
                    type={type}
                    label={label}
                    variant={variant}
                    className={className}
                    {...validation_error.length ? { error: true } : { error: false }}
                    {...validation_error.length ? { helperText: validation_error } : { helperText: "" }}
                    {...value.length ? { value: value } : { value: "" }}
                    {...props}
                />
            </div>
        </>
    );
};
export default MUIInputField;